<template>
    <div
        ref="dropdown"
        class="base-form-dropdown"
        :class="{
            'base-form-dropdown--open': dropdownOpen
        }"
    >
        <div class="base-form-dropdown__wrapper">
            <div
                class="base-form-dropdown__label"
                @click="toggleDropdown"
            >
                <slot name="label" />

                <BaseIcon
                    v-if="showIcon"
                    icon="expand"
                />
            </div>
            <transition name="fade">
                <div
                    v-if="dropdownOpen"
                    class="base-form-dropdown__content"
                >
                    <slot
                        name="content"
                        v-bind="{ toggleDropdown }"
                    />
                </div>
            </transition>
        </div>

        <div
            v-if="!!$slots.description"
            class="base-form-dropdown__description"
        >
            <slot name="description" />
        </div>
    </div>
</template>

<script setup>
import { onClickOutside } from '@vueuse/core';

defineProps({
    showIcon: {
        type: Boolean,
        required: false,
        default: false
    }
});

const dropdown = ref(null);
const dropdownOpen = ref(false);

// Close dropdown when clicking outside
onClickOutside(dropdown, () => dropdownOpen.value = false);

function toggleDropdown() {
    if (dropdownOpen.value) {
        dropdownOpen.value = false;
    } else {
        dropdownOpen.value = true;
    }
}
</script>

<style lang="less">
.base-form-dropdown__wrapper {
    position: relative;
}

.base-form-dropdown__content {
    position: absolute;
    z-index: 99;
    top: 100%;
    width: 100%;
    
    padding: var(--spacing-xs);
    background: var(--color-lightest);
}

.base-form-dropdown__label {
    .typography-label();

    padding-block: .875rem;
    border-bottom: 1px solid rgba(0, 0, 0, .25);
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-self: center;
}

.base-form-dropdown__description {
    color: var(--color-dark);
    opacity: .5;
    margin-top: .875rem;
    line-height: var(--lineHeight-md);
}

.base-form-dropdown--open {
    .base-icon {
        transform: scaleY(-1) translateY(33.333%);
    }
}
</style>